__turbopack_context__.v({
  "cards": "t_J0lW_cards",
  "cardsList": "t_J0lW_cardsList",
  "container": "t_J0lW_container",
  "csbButton": "t_J0lW_csbButton",
  "hasThreeOrMoreCards": "t_J0lW_hasThreeOrMoreCards",
  "info": "t_J0lW_info",
  "jump": "t_J0lW_jump",
  "jumpButtons": "t_J0lW_jumpButtons",
  "label": "t_J0lW_label",
  "relatedButtons": "t_J0lW_relatedButtons",
  "stats": "t_J0lW_stats",
  "title": "t_J0lW_title",
  "top": "t_J0lW_top",
});
